/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import StickersToolsTabs from "./StickersToolsTabs.vue";
// import StickersToolsShape from "./StickersToolsShape";
import StickersToolsBackground from "./StickersToolsBackground.vue";
import StickersToolsBorder from "./StickersToolsBorder.vue";
import "./StickersTools.scss";

export default function StickersTools({ artwork, ...restProps }: any) {
  return (
    <div {...restProps} className={cn("stickers-tools", restProps.className)}>
      <StickersToolsTabs
        artwork={artwork}
        slots={{
          default: ({ tab }: any) => (
            <>
              {tab === "background" ? (
                <StickersToolsBackground
                  artwork={artwork}
                  data-testid="stickers-tools-background"
                />
              ) : tab === "border" ? (
                <StickersToolsBorder artwork={artwork} data-testid="stickers-tools-border" />
              ) : null}
            </>
          )
        }}
        data-testid="stickers-tools-tabs"
      />
    </div>
  );
}
